//getters，主要用来导出全局的state
export default {
    userInfo: state => state.user.userInfo,
    navbar: state => state.navbar.navbar
};